// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MultiPaperNewsStory-cls1___e366cd72087fa09d9bc{/*!*/}.MultiPaperNewsStory-cls2___7035378745ecd21d61f{}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "MultiPaperNewsStory-cls1___e366cd72087fa09d9bc",
	"cls2": "MultiPaperNewsStory-cls2___7035378745ecd21d61f MultiPaperNewsStory-cls1___e366cd72087fa09d9bc"
};
export default ___CSS_LOADER_EXPORT___;
